/**
 * Metrics Page Service
 * Provides data fetching functions for metrics charts
 */
import { commonServerInstance } from '@/utilities/instances'

// Chart data interfaces
export interface QuarantineRateData {
  date_range: {
    start_date: string
    end_date: string
  }
  partners: number[]
  series: {
    date: string
    weighted_average_rate: number
    partners: {
      partner_id: number
      quarantine_cnt: number
      all_cnt: number
      quarantine_rate: number
    }[]
  }[]
}

export interface VolumeComparisonData {
  date_range: {
    start_date: string
    end_date: string
  }
  partners: number[]
  series: {
    date: string
    selected_total: number
    overall_total: number
    partners: {
      partner_id: number
      quarantine_cnt: number
      all_cnt: number
    }[]
  }[]
}

// Filter parameters interfaces
export interface QuarantineRateFilters {
  start_date?: string
  end_date?: string
}

export interface VolumeComparisonFilters {
  start_date?: string
  end_date?: string
  comparison_type?: string
}

/**
 * Fetch Quarantine Rate trend data
 * @param filters - Filter parameters including date range
 * @returns Promise with quarantine rate data
 */
export const fetchQuarantineRateData = async (
  filters: {
    partner_ids: number[]
    start_date: string
    end_date: string
  } = { partner_ids: [], start_date: '', end_date: '' }
): Promise<QuarantineRateData> => {
  const response = await commonServerInstance.get(
    '/api/v1/data-quality/quarantine-rate',
    {
      params: filters
    }
  )
  return response?.data?.data
}

/**
 * Fetch Volume Comparison data
 * @param filters - Filter parameters including date range and comparison type
 * @returns Promise with volume comparison data
 */
export const fetchVolumeComparisonData = async (
  filters: {
    partner_ids: number[]
    start_date: string
    end_date: string
  } = { partner_ids: [], start_date: '', end_date: '' }
): Promise<VolumeComparisonData> => {
  const response = await commonServerInstance.get(
    '/api/v1/data-quality/total-parcels',
    {
      params: filters
    }
  )
  return response?.data?.data
}
